const eventNames$3 = {
    internals: {
        login: 'app-shell:gotoLoginClicked',
        logout: 'app-shell:gotoLogoutClicked',
        abortLogin: 'app-shell:abortLoginClicked',
        refreshUserProfile: 'app-shell:refreshUserProfile',
        toggleArbetsgivareCookie: 'app-shell:toggleArbetsgivareCookie',
        redirectToAuthServer: 'app-shell:redirectToAuthServer',
        userCreationFinished: 'app-shell:userCreationFinished',
        loginFlowRefreshUserToken: 'app-shell:loginFlowRefreshUserToken',
        gtmCustomEventName: 'app-shell:gtmCustomEvent',
        applicationInsightsEventName: 'app-shell:applicationInsightsEvent',
    },
};
const __api_internals__ = {
    eventNames: eventNames$3.internals,
};

const eventNames$2 = __api_internals__.eventNames;
const createCustomEvent = (e) => new CustomEvent(eventNames$2.applicationInsightsEventName, {
    bubbles: true,
    detail: e,
});
// Fire a custom event with details of a application insights logging action
const __internal__dispatchApplicationInsightsEvent = (event) => dispatchEvent(createCustomEvent(event));

const AI_VERSION = 3;
const AI_ACTIONS = {
    trackEvent: 'trackEvent',
    trackException: 'trackException',
    trackDependencyData: 'trackDependencyData',
    __internal: {
        clearAuthenticatedUserContext: '__internal__clearAuthenticatedUserContext',
    },
};
const trackEvent = (eventTelemetry, customProperties) => {
    __internal__dispatchApplicationInsightsEvent({
        aiVersion: AI_VERSION,
        azureReleaseId: process.env.BUILD_BUILDID,
        action: AI_ACTIONS.trackEvent,
        payload: {
            eventTelemetry,
            customProperties,
        },
    });
};
const trackException = (exceptionTelemetry) => {
    __internal__dispatchApplicationInsightsEvent({
        aiVersion: AI_VERSION,
        azureReleaseId: process.env.BUILD_BUILDID,
        action: AI_ACTIONS.trackException,
        payload: { exceptionTelemetry },
    });
};
const trackDependencyData = (dependencyTelemetry) => {
    __internal__dispatchApplicationInsightsEvent({
        aiVersion: AI_VERSION,
        action: AI_ACTIONS.trackDependencyData,
        payload: { dependencyTelemetry },
    });
};
const __internalEvents = {
    clearAuthenticatedUserContext: () => {
        __internal__dispatchApplicationInsightsEvent({
            aiVersion: AI_VERSION,
            action: AI_ACTIONS.__internal.clearAuthenticatedUserContext,
            payload: undefined,
        });
    },
};

var UserType;
(function (UserType) {
    UserType[UserType["client"] = 0] = "client";
    UserType[UserType["customer"] = 1] = "customer";
})(UserType || (UserType = {}));
const eventNames$1 = __api_internals__.eventNames;
const dispatchLoginEvent = ({ redirectUrl, userType, historyAction, }) => {
    window.dispatchEvent(new CustomEvent(eventNames$1.login, {
        bubbles: true,
        detail: { redirectUrl, userType, historyAction },
    }));
};
/**
 * Dispatches event that starts login flow for anställd
 * @param {string} redirectUrl - optional url for where to redirect after login.
 * @param userType - Allows developer to tell the Public-web if a user should find themselves on client login or company login
 */
const goToLogin = (redirectUrl, userType = UserType.client, historyAction = 'push') => {
    dispatchLoginEvent({
        redirectUrl: redirectUrl,
        userType: userType,
        historyAction,
    });
};
/**
 * Dispatches event that starts login flow for arbetsgivare
 * @param {string} redirectUrl - optional url for where to redirect after login. If not attached, user will return to where this event was dispatched
 */
const goToLoginEmployer = (redirectUrl) => {
    goToLogin(redirectUrl, UserType.customer);
};
/**
 * Dispatches event that starts the logout flow
 */
const goToLogout = () => {
    window.dispatchEvent(new CustomEvent(eventNames$1.logout, { bubbles: true }));
};
/**
 * Dispatches event that aborts login flow
 */
const abortLogin = () => {
    window.dispatchEvent(new CustomEvent(eventNames$1.abortLogin, { bubbles: true }));
};
/**
 * Dispatches event for redirection from Loginflow-MicroFrontend to ID-server.
 * NOTE! Used only by the Loginflow-Microfrontend. All others should use goToLogin/goToLoginEmployer
 * @param {string} authenticationMethod - the chosen authentication method (e.g. BankID on this device or some such)
 * @param userType - Allows developer to tell the Public-web which user-type when redirecting to the Auth server
 */
const redirectToAuthServer = (authenticationMethod = '', userType = UserType.client) => {
    window.dispatchEvent(new CustomEvent(eventNames$1.redirectToAuthServer, {
        bubbles: true,
        detail: { authenticationMethod, userType },
    }));
};
const redirectToAuthServerEmployer = (authenticationMethod) => {
    redirectToAuthServer(authenticationMethod, UserType.customer);
};
/**
 * Dispatches event for creation and updates token
 * NOTE! Used only by the Loginflow-Microfrontend. NO OTHER MF SHOULD USE THIS!!
 * @param redirect - do the subsequential redirect to redirecturl
 */
const userCreationFinished = (redirect) => {
    window.dispatchEvent(new CustomEvent(eventNames$1.userCreationFinished, {
        bubbles: true,
        detail: redirect,
    }));
};
/**
 * Dispatches event that fetches or updates a user token.
 * NOTE! Used only by the Loginflow-Microfrontend. NO OTHER MF SHOULD USE THIS!!
 */
const loginFlowRefreshUserToken = (callback) => {
    window.dispatchEvent(new CustomEvent(eventNames$1.loginFlowRefreshUserToken, {
        bubbles: true,
        detail: {
            callback: callback,
        },
    }));
};

const refreshUserProfile = (callback) => {
    window.dispatchEvent(new CustomEvent(__api_internals__.eventNames.refreshUserProfile, {
        bubbles: true,
        detail: { callback: callback },
    }));
};

const eventNames = __api_internals__.eventNames;
const gtmCustomEvent = (e) => new CustomEvent(eventNames.gtmCustomEventName, {
    bubbles: true,
    detail: e,
});
/**
 * Internal function - not to be used by any consumer other than appshell
 * Push a custom event to the GTM datalayer
 *
 * @param  {string}  e.event_action - The action of the event, e.g. ```click```.
 * @param  {string}   e.event_item - The item of the event, e.g. ```button```.
 * @param  {customData}   e.event_data - An array of key/value pairs, e.g ```
 * [{key: age, value: 30}, {key: height, value: 189}].```
 * @param  {string=}   mfName - The name of the triggering mf, e.g ```meetings```
 * @param  {boolean}   overrideGtmEnabledBlock - Override the block for sending events
 * to GTM if you do not have a gtm.enabled.MfName feature flag. Only to be used in app-shell.
 *
 */
const internal_trackGtmCustomEvent = (e) => dispatchEvent(gtmCustomEvent(e));

const applicationInsights = {
    AI_ACTIONS,
    AI_VERSION,
    trackDependencyData,
    trackEvent,
    trackException,
    __internalEvents,
    __internal__dispatchApplicationInsightsEvent,
};

export { __api_internals__, abortLogin, applicationInsights, goToLogin, goToLoginEmployer, goToLogout, internal_trackGtmCustomEvent, loginFlowRefreshUserToken, redirectToAuthServer, redirectToAuthServerEmployer, refreshUserProfile, userCreationFinished };
//# sourceMappingURL=index.esm.js.map
